<template>
  <div class="Banner wow bounceInDown">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="bannerImg">
            <div class="cont_lable">
              <div class="lable_EN wow bounceInLeft" data-wow-delay=".5s">
                {{ bannerObj.lableEn }}
              </div>
              <div class="lable_ZH wow bounceInLeft" data-wow-delay="1s">
                {{ bannerObj.lableZh }}
              </div>
            </div>
            <img class="banner_bg" :src="bannerObj.bannerImg" alt="banner" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "pageBanner",
  props: ["bannerObj"],
  data() {
    return {};
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
    new Swiper(".swiper-container", {
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      autoResize: true,
      watchActiveIndex: true,
      lazyLoading: true, // 图片懒加载
      lazyLoadingInPrevNext: true,
      preventLinksPropagation: false,
      preventClicks: false,
      visibilityFullFit: true,
      updateOnImagesReady: true, // 所有内部图像（<img>标签）装入后重新初始化Swipe
      calculateHeight: true, // 当值为true时，
    });
  },
};
</script>

<style lang="scss" scoped>
$minWidth: 1180px;
$minHeight: 370px;
.Banner {
  width: 100%;
  min-width: $minWidth;
  position: relative;
  /deep/ .bannerImg {
    width: 100%;
    height: $minHeight;
    min-width: $minWidth;
    position: relative;
    .banner_bg {
      display: block;
      width: 100%;
      height: $minHeight;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  .cont_lable {
    width: $minWidth;
    height: 80px;
    position: absolute;
    top: 140px;
    left: 50%;
    z-index: 6;
    transform: translate(-50%, 0);
    color: #ffffff;
    &::after {
      content: "";
      display: block;
      width: 94px;
      height: 2px;
      background-color: #ffffff;
    }
    .lable_EN {
      font-size: 18px;
    }
    .lable_ZH {
      font-size: 24px;
      padding: 10px 0;
    }
  }
}
</style>
